"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.migrateToQuoteV2 = exports.default = void 0;

var _element = require("@wordpress/element");

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _blocks = require("@wordpress/blocks");

var _blockEditor = require("@wordpress/block-editor");

var _deprecated = _interopRequireDefault(require("../deprecated"));

/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
const migrateToQuoteV2 = attributes => {
  const {
    value
  } = attributes;
  return [{ ...(0, _lodash.omit)(attributes, ['value'])
  }, value ? (0, _blocks.parseWithAttributeSchema)(value, {
    type: 'array',
    source: 'query',
    selector: 'p',
    query: {
      content: {
        type: 'string',
        source: 'html'
      }
    }
  }).map(_ref => {
    let {
      content
    } = _ref;
    return (0, _blocks.createBlock)('core/paragraph', {
      content
    });
  }) : (0, _blocks.createBlock)('core/paragraph')];
};

exports.migrateToQuoteV2 = migrateToQuoteV2;
const v3 = {
  attributes: {
    value: {
      type: 'string',
      source: 'html',
      selector: 'blockquote',
      multiline: 'p',
      default: '',
      __experimentalRole: 'content'
    },
    citation: {
      type: 'string',
      source: 'html',
      selector: 'cite',
      default: '',
      __experimentalRole: 'content'
    },
    align: {
      type: 'string'
    }
  },
  supports: {
    anchor: true,
    __experimentalSlashInserter: true,
    typography: {
      fontSize: true,
      lineHeight: true,
      __experimentalFontStyle: true,
      __experimentalFontWeight: true,
      __experimentalLetterSpacing: true,
      __experimentalTextTransform: true,
      __experimentalDefaultControls: {
        fontSize: true,
        fontAppearance: true
      }
    }
  },

  save(_ref2) {
    let {
      attributes
    } = _ref2;
    const {
      align,
      value,
      citation
    } = attributes;
    const className = (0, _classnames.default)({
      [`has-text-align-${align}`]: align
    });
    return (0, _element.createElement)("blockquote", _blockEditor.useBlockProps.save({
      className
    }), (0, _element.createElement)(_blockEditor.RichText.Content, {
      multiline: true,
      value: value
    }), !_blockEditor.RichText.isEmpty(citation) && (0, _element.createElement)(_blockEditor.RichText.Content, {
      tagName: "cite",
      value: citation
    }));
  },

  migrate: migrateToQuoteV2
};
/**
 * New deprecations need to be placed first
 * for them to have higher priority.
 *
 * Old deprecations may need to be updated as well.
 *
 * See block-deprecation.md
 */

var _default = [v3, ..._deprecated.default];
exports.default = _default;
//# sourceMappingURL=deprecated.js.map